module.exports = __webpack_public_path__ + "static/media/food.66a1ec14.jpg";